// Our local modules.
import initDatepickers from './custom_modules/datepicker/datepicker';
import * as datepickerLanguage from './custom_modules/datepicker/i18n';
import * as datepickerTheme from './custom_modules/datepicker/theme';
import initAirportFields, { i18n as airportFieldLanguage } from './custom_modules/airportField/airportFields';
import airlineFields, { i18n as airlineFieldLanguage } from './custom_modules/airlineField/airlineFields';
import './custom_modules/maskedInput/maskedInputs';
import './custom_modules/mediaObjectCover';

// Modules from our own NPM registry.
import autoFontPlugin from '@fr/autofont-signature';
import signaturePad from '@fr/signature-pad';
import { initNotification } from '@fr/notification';
import { initDisclosures, initDisclosure } from '@fr/disclosure';
import { initTabbedInterfaces, initTabbedInterface } from '@fr/tabbed';
import { initSendSMSForm, submitSMSForm, sendSMS } from '@fr/sms-form';
import { getDateRangeFromToday, DateRanges } from '@fr/date-utils';
import '@fr/extender';
import initAccordions from '@fr/accordion';
import '@fr/amount-spinner';
import capitalize from '@fr/capitalize';
import normalizeHeight from '@fr/normalize-height';
import normalizeWidth from '@fr/normalize-width';
import moment from '@fr/moment';
import { getPromoCode, setPromoCode, deletePromoCode } from '@fr/promo-code';
import '@fr/dropdown';
import initCarousels from '@fr/carousel';
import modal from '@fr/modal';
import formValidation from '@fr/form-validation';
import tooltipNotification from '@fr/tooltip-notification';
import { getParam } from '@fr/query-param';
import * as rwd from '@fr/rwd';
import '@fr/polyfills';

// Modules from the official NPM registry.
import 'babel-polyfill';
import 'jquery';
import 'modernizr';
import 'columnizer';
import 'jqueryCustomSelect';
import browserUpdate from 'browser-update';

var core = {

  /**
   * Autofont generator module.
   * @type {Object}
   */
  autoFontPlugin,

  /**
   * Responsive Web Design tools module.
   * @type {Object}
   */
  rwd,

  /**
   * Modal module to fire modals.
   * @type {Object}
   */
  modal,

  /**
   * Form validation tools module to validate fields, forms...
   * @type {Object}
   */
  formValidation,

  /**
   * Translation configuration of the pickadate(datepicker) plugin.
   * @type {Object}
   */
  datepickerLanguage,

  /**
   * Theme configuration of the pickadate(datepicker) plugin.
   * @type {Object}
   */
  datepickerTheme,

  /**
   * Translation configuration of the airportField plugin.
   * @type {Object}
   */
  airportFieldLanguage,

  /**
   * Wrapper to http://momentjs.com.
   * @type {Object}
   */
  moment,

  /**
   * Wrapper to the get method of queryParam.
   * @type {Object}
   */
  getParam,

  /**
   * Wrapper to the capitalize functions.
   * @type {Object}
   */
  capitalize,

  /*
   * Wrapper to the tooltipNotification methods.
   * @type {Object}
   */
  tooltipNotification,

  /**
   * Wrapper to the normalizeHeight functions.
   * @type {Object}
   */
  normalizeHeight,

  /**
   * Wrapper to the signature function.
   * @type {Object}
   */
  signaturePad,

  /**
   * Wrapper to the normalizeWidth functions.
   * @type {Object}
   */
  normalizeWidth,

  /*
   * Wrapper to the getPromoCode method from promoCode module.
   * @type {Object}
   */
  getPromoCode,

  /**
   * Function to init a notification component.
   * @type {object}
   */
  initNotification,

  /**
   * Function to init a disclosure component.
   * @type {object}
   */
  initDisclosure,

  /**
   * Function to init a tabbed interface component.
   * @type {object}
   */
  initTabbedInterface,

  /**
   * Wrapper to the accordion methods.
   * @type {Object}
   */
  initAccordions,

  /**
   * Functions from the send-sms module.
   * @type {object}
   */
  sendSMS,
  initSendSMSForm,
  submitSMSForm,

  /*
   * Wrapper to the getDateRangeFromToday method from 'date-utils'.
   * @type {Object}
   */
  getDateRangeFromToday,

  /**
   * Wrapper to the DateRanges const from 'date-utils'.
   * @type {Object}
   */
  DateRanges,

/**
   * Translation configuration of the airlineField plugin.
   * @type {Object}
   */
 airlineFieldLanguage,

  init: function() {

/* BROWSER UPDATE
   ========================================================================== */

    // Get some insights there: http://browser-update.org/#install
    browserUpdate({vs:{i:10,f:-8,o:-8,s:8,c:-8},unsecure:true,api:4});


    document.addEventListener('DOMContentLoaded', () => {
      initDisclosures();
    });


    $(function() {





/* DATEPICKERS
   ========================================================================== */
      initDatepickers();






/* CAROUSELS
   ========================================================================== */
      initCarousels();





/* ACCORDION
   ========================================================================== */
      initAccordions();




/* MODERNIZR
   ========================================================================== */
      /**
       * Check for support for input type time.
       *
       * 1. Class name to target CSS rules to be taken into account when feature
       *    is supported.
       * 2. Class name to target CSS rules to be taken into account when feature
       *    is not supported.
       */
      if(Modernizr.inputtypes.time) {
        document.documentElement.className += '  inputtime'; /* [1] */
      }
      else {
        document.documentElement.className += '  no-inputtime'; /* [2] */
      }





/* TOOLTIP NOTIFICATION
   ========================================================================== */
  tooltipNotification();





/* CUSTOM SELECTS
   ========================================================================== */
      $('.custom-select:visible').each(function() {
        if(!$(this).hasClass('hasCustomSelect')) {
          $(this).customSelect();
        }
      });





/* MODAL WINDOWS
   ========================================================================== */
      if($('[data-toggle-modal]').length > 0) {
        modal.init();
      }





/* AMOUNT SPINNERS
   ========================================================================== */
      if($('.amount-spinner').length > 0) {
        $('.amount-spinner').each(function() {
          if(!$(this).hasClass('hasAmountSpinner')) {
            $(this).amountSpinner();
          }
        });
      }










/* AIRPORT FIELDS
   ========================================================================== */
      initAirportFields();



/* AIRLINE FIELDS
   ========================================================================== */
   airlineFields.init();


/* EXTENDER
    ========================================================================== */
       $('.extender').each(function() {
         $(this).extender();
       });


    });






/* PROMOCODE
   ========================================================================== */

    // Cleanup for potential conflictual visits (see: PROD-558).
    if(getPromoCode() != null && getPromoCode().match(/^flugrecht.*/) !== null && !getParam('partner')) {
      deletePromoCode();
    }

    setPromoCode();

  }

};


/**
 * Self anonymous invoking function that initializes all the component that need to be instancied or initialized for
 * any page calling this core initialization.
 */
(function() {

  core.init();

}());

export default core;
